<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="名称">
                  <el-input style="width: 177px" v-model="queryForm.categoryName"></el-input>
              </el-form-item>
              <el-form-item label="父级分类">
<!--                  <el-input  v-model="queryForm.parentId"></el-input>-->
                  <el-select
                      clearable
                      style="width: 177px"
                      v-model="queryForm.parentId"
                      placeholder="请选择"
                      size="small"
                  >
                      <el-tree
                          :data="eduExerciseCategoryList"
                          :props="treeProps"
                          :render-after-expand="false"
                      >
                          <div
                              class="custom-tree-node flex items-center"
                              slot-scope="{ node, data }"
                          >
                              <el-option
                                  :label="node.label"
                                  :value="data.id"
                              > </el-option>
                          </div>
                      </el-tree>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getEduExerciseCategoryList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addEduExerciseCategory"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editEduExerciseCategory(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteEduExerciseCategory(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
<!--            <el-upload v-if="this.isImportDate"-->
<!--              class="upload-demo"-->
<!--              action="#"-->
<!--                            :http-request="upload"-->
<!--              :show-file-list="true">-->
<!--              <el-button size="small" type="primary">点击上传</el-button>-->
<!--              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>-->
<!--            </el-upload>-->
<!--        <span-->
<!--          title="搜索"-->
<!--          class="icon-box"-->
<!--          @click="search"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <Search />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportEduExerciseCategoryList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshEduExerciseCategoryList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="eduExerciseCategoryList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        prop="categoryName"
        label="名称"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="parentId"
        label="父级分类"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sort"
        label="排序"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkEduExerciseCategory(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editEduExerciseCategory(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteEduExerciseCategory(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
              <div @click="addChildCourseCategory(scop.row.id)">
                  <Icon size="16">
                      <Eye24Regular />
                  </Icon>
                  <span class="operation-label">添加下级分类</span>
              </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
<!--    <div class="pagination-box">-->
<!--      <el-pagination-->
<!--        @size-change="sizeChange"-->
<!--        @current-change="currentChange"-->
<!--        :current-page.sync="currentPage"-->
<!--        :page-sizes="[10, 20, 50, 100]"-->
<!--        :page-size="pageSize"-->
<!--        layout="total, sizes, prev, pager, next, jumper"-->
<!--        :total="totalNum"-->
<!--        background-->
<!--        :pager-count="7"-->
<!--      >-->
<!--      </el-pagination>-->
<!--    </div>-->
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="eduExerciseCategoryStates[eduExerciseCategoryState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="eduExerciseCategory"
          ref="eduExerciseCategoryForm"
          :rules="rules"
          label-width="80px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="名称"
            prop="categoryName"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="eduExerciseCategory.categoryName"
              :disabled="eduExerciseCategoryState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="父级分类"
            prop="parentId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduExerciseCategory.parentId"-->
<!--              :disabled="eduExerciseCategoryState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  clearable
                  style="width: 177px"
                  :disabled="eduExerciseCategoryState == 'check'"
                  v-model="eduExerciseCategory.parentId"
                  placeholder="请选择"
                  size="small"
              >
                  <el-tree
                      :data="eduExerciseCategoryList"
                      :props="treeProps"
                      :render-after-expand="false"
                  >
                      <div
                          class="custom-tree-node flex items-center"
                          slot-scope="{ node, data }"
                      >
                          <el-option
                              :label="node.label"
                              :value="data.id"
                          > </el-option>
                      </div>
                  </el-tree>
              </el-select>
          </el-form-item>
          <el-form-item
            label="排序"
            prop="sort"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduExerciseCategory.sort"-->
<!--              :disabled="eduExerciseCategoryState == 'check'"-->
<!--            ></el-input>-->
              <el-input-number
                  style="width: 177px"
                  :disabled="eduExerciseCategoryState == 'check'"
                  v-model="eduExerciseCategory.sort"
                  size="small"
                  label=""
                  :min="1"
                  :max="100000"
                  :step="1"
                  :controls="true"
                  controls-position="both"
              >
              </el-input-number>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="eduExerciseCategoryState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetEduExerciseCategoryList();
                    this.getEduExerciseCategoryList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetEduExerciseCategoryList();
                    this.getEduExerciseCategoryList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     categoryName: '', //名称
                     parentId: '', //父ID
                     sort: '', //排序
                },
                treeProps: {
                    children: 'children',
                    label: 'categoryName'
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 1,
                currentUserId: '',
                eduExerciseCategoryState: 'add',
                eduExerciseCategoryStates: {
                    add: '新建习题分类',
                    check: '查看习题分类',
                    edit: '修改习题分类'
                },

                multipleSelection: [],
                eduExerciseCategoryList: [],
                eduExerciseCategory: {
                    id: '', //
                    categoryName: '', //名称
                    parentId: '', //父ID
                    sort: '', //排序
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    categoryName: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
                    // parentId: [{ required: true, message: '父ID不能为空', trigger: 'blur' }],
                    sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                    createUserId: [{ required: true, message: '创建用户不能为空', trigger: 'blur' }],
                    createTime: [{ required: true, message: '创建时间不能为空', trigger: 'blur' }],
                    updateUserId: [{ required: true, message: '更新用户不能为空', trigger: 'blur' }],
                    updateTime: [{ required: true, message: '更新时间不能为空', trigger: 'blur' }],
                    deleteFlag: [{ required: true, message: '0正常 1删除不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getEduExerciseCategoryList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetEduExerciseCategoryList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.eduExerciseCategoryList = [];
            },
            resetDialog() {
                this.eduExerciseCategoryState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      categoryName: '', //名称
                      parentId: '', //父ID
                      sort: '', //排序
                };
                this.getEduExerciseCategoryList();
            },
            addChildCourseCategory(id){
                this.addEduExerciseCategory()
                this.eduExerciseCategory.parentId = id
            },
            closeDialog() {
                this.showDialog = false
                this.eduExerciseCategory = {
                      id: '', //
                      categoryName: '', //名称
                      parentId: '', //父ID
                      sort: '', //排序
                };
            },
            submitForm() {
                if (this.eduExerciseCategoryState == 'add') {
                    this.$refs.eduExerciseCategoryForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/edu/exercisecategory/add`,{ ...this.eduExerciseCategory }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetEduExerciseCategoryList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.eduExerciseCategoryState == 'edit') {
                    this.$refs.eduExerciseCategoryForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.eduExerciseCategory.children
                            delete this.eduExerciseCategory.updateTime
                            post(`/edu/exercisecategory/edit`,{ ...this.eduExerciseCategory }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetEduExerciseCategoryList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addEduExerciseCategory() {
                this.showDialog = true;
                this.eduExerciseCategoryState = 'add';
            },
            checkEduExerciseCategory(eduExerciseCategoryId) {
                console.log(eduExerciseCategoryId);
                this.currentEduExerciseCategoryId = eduExerciseCategoryId;

                this.getEduExerciseCategoryById();
                this.showDialog = true;
                this.eduExerciseCategoryState = 'check';
            },
            editEduExerciseCategory(eduExerciseCategoryId) {
                console.log('eduExerciseCategory', eduExerciseCategoryId);
                if (eduExerciseCategoryId) {
                    this.currentEduExerciseCategoryId = eduExerciseCategoryId;
                    this.getEduExerciseCategoryById();
                } else {
                    this.eduExerciseCategory = { ...this.eduExerciseCategory, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.eduExerciseCategoryState = 'edit';
            },
            deleteEduExerciseCategory(eduExerciseCategoryId) {
                let ids = '';
                if (eduExerciseCategoryId) {
                    ids = eduExerciseCategoryId;
                } else {
                    ids = this.multipleSelection.map((eduExerciseCategory) => eduExerciseCategory.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/edu/exercisecategory/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetEduExerciseCategoryList();
                                this.getEduExerciseCategoryList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshEduExerciseCategoryList() {
                this.resetEduExerciseCategoryList();
                this.getEduExerciseCategoryList();
            },
            getEduExerciseCategoryList(query = {}) {
                this.loading = true;
                get(`/edu/exercisecategory/findAllAsTree`,{  ...this.queryForm }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.eduExerciseCategoryList = res.treeData;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getEduExerciseCategoryById() {
                get(`/edu/exercisecategory/get`,{ id: this.currentEduExerciseCategoryId }).then((res) =>{
                    if(res.success){
                      this.eduExerciseCategory = { ...this.eduExerciseCategory, ...res.eduExerciseCategory };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportEduExerciseCategoryList() {
                //this.btnLoading = true;
                exprotExcel(`/edu/exercisecategory/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/edu/exercisecategory/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/edu/exercisecategory/importData`,formData);
              this.refreshEduExerciseCategoryList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getEduExerciseCategoryList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getEduExerciseCategoryList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>